module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-30.297dc904.png";